import script from "./PostComplaints.vue?vue&type=script&setup=true&lang=js"
export * from "./PostComplaints.vue?vue&type=script&setup=true&lang=js"

import "./PostComplaints.vue?vue&type=style&index=0&id=b4b57ea2&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b57ea2"]])

export default __exports__